var $60886f131a8aaf64$exports = {};
$60886f131a8aaf64$exports = {
    "endTime": `\u{7D42}\u{4E86}\u{6642}\u{523B}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{523B}`,
    "time": `\u{6642}\u{523B}`
};


export {$60886f131a8aaf64$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
